export const PROFILES = {
    KEYBOARD: "keyboardNav",
    SCREEN_READER: "screenReader",
    COLOR_CONTRAST: "contrast",
    GRAY_SCALE: "grayscale",
    MAGNIFY: "magnify"
}